import React from "react";
export enum Directions {
  RTL = "rtl",
  LTR = "ltr",
}

export enum Languages {
  ENGLISH = "en",
  ARABIC = "ar",
}

export enum ClassStatus {
  COMPLETED = "completed",
  IN_PROGRESS = "in_progress",
}

export enum LevelStatus {
  COMPLETED = "completed",
  IN_PROGRESS = "in_progress",
}

export enum Pages {
  OVERVIEW = "overview",
  STORES = "stores",
  PLANS = "plans",
}

export enum Resources {
  USERS = "users",
  DOCTORS="doctors",
  SETTINGS="settings",
  POLICIES="policies",
  FAQS="faqs",
  QUESTIONS="questions",
  Treatments="treatments",
  GOALS="goals",
  ABOUT_US="about-us",
  UPDATE_PASSWORD="update-password",
  ECONSULTATION_USERS="EConsultation-users",
}

export enum Models {
  CATEGORY = "Category",
  ORDER = "Order",
  PRODUCT = "Product",
  MEDIA_LIBRARY = "media",
  CHAT = "Chat",
  RATING = "Rating",
  VENDOR = "Vendor",
  CUSTOM_CONTENT = "CustomContent",
  CUSTOM_THUMBNAIL = "CustomThumbnail",
  USER = "User",
}

export enum AuthErrors {
  USER_EXISTS = "UsernameExistsException",
}

export enum InputTypes {
  TEXT = "text",
  EMAIL = "email",
  PASSWORD = "password",
  NUMBER = "number",
  PHONE = "phone",
  DATE = "date",
  COUNTRY = "country",
  TIME = "time",
  DATE_TIME_LOCAL = "datetime-local",
  CHECKBOX = "checkbox",
  RADIO = "radio",
  TEXTAREA = "textarea",
  FILE = "file",
  IMAGE = "image",
  COLOR = "color",
  RANGE = "range",
  TEL = "tel",
  URL = "url",
  SEARCH = "search",
  MONTH = "month",
  WEEK = "week",
  HIDDEN = "hidden",
  SELECT = "select",
  SELECT_WITH_INPUT = "select with input",
  MULTI_SELECT = "multi select",
  EDITOR = "editor",
  CHECKBOXES = "checkboxes",
  CALENDER = "calender",
  SWITCH = "switch",
 
}

export enum Navigate {
  NEXT = "next",
  PREV = "prev",
}
export enum Responses {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

export enum SortOrder {
  ASC = "asc",
  DESC = "desc",
}
export type Order = "asc" | "desc";

export enum SortBy {
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
  NAME = "name",
  EMAIL = "email",
  PHONE = "phone",
  STATUS = "status",
  START_DATE = "startDate",
  END_DATE = "endDate",
}

export enum Cookies {
  SESSION = "session",
  ACCOUNT = "account",
}

export enum AuthMessages {
  LOGIN_SUCCESS = "Login successfully",
  LOGOUT_SUCCESS = "Logout successfully",
  REGISTER_SUCCESS = "Register successfully",
  FORGET_PASSWORD_SUCCESS = "Forget password successfully",
  RESET_PASSWORD_SUCCESS = "Reset password successfully",
}

export enum FormActions {
  CREATE = "Create",
  UPDATE = "Update",
}

export enum MODAL_TYPES {
  RESOURCE = "resource",
  MEDIA = "media",
}

export enum Statuses {
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
  BUSY = "busy",
}

export enum Methods {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum PaymentTypes {
  DOMAIN = "domain",
  SUBSCRIPTION = "subscription",
}

export enum Messages {
  SUCCESS = "Success",
}
export enum CHARTS {
  BAR = "bar",
  BAR2 = "bar2",
  BAR3 = "bar3",
  LINE = "line",
  LINE2 = "line2",
  PIE = "pie",
  DOUGHNUT = "doughnut",
  POLAR_AREA = "polarArea",
  RADAR = "radar",
  BUBBLE = "bubble",
  MULTI_BAR_CHART = "multiBarChart",
  MULTI_BAR_CHART2 = "multiBarChart2",
  MULTI_BAR_CHART3 = "multiBarChart3",
  GUAGE = "guage",
  AREA = "area",
}
